import React from "react";

const DataPenumpangTerminal = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data Penumpang Terminal"
        src="https://lookerstudio.google.com/embed/reporting/127a897b-d906-418c-867a-f5cbed345d58/page/DjPSD"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default DataPenumpangTerminal;
